exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{min-width:1200px}#app .warn-content{font-size:16px;padding:0 20px}#app .warn-content:not(:first-child){margin-top:20px}#app .content-wrap{background:#fff}", ""]);

// exports
